$(document).ready(function () {

    if ($('.js-eq-product-ingredients-slider').length > 0) {
        $('.js-eq-product-ingredients-slider').slick({
            prevArrow: $(".js-cus-ingredients-slick-arrow-prev"),
            nextArrow: $(".js-cus-ingredients-slick-arrow-next"),
            arrows: true,
            slidesToShow: 2.4,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1.8,
                        slidesToScroll: 1,
                        infinite: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.3,
                        slidesToScroll: 1,
                        infinite: true,
                        arrows: false,
                    }
                }
            ]
        });
    }


    // if($('.js-product-slide-for').length > 0 && $('.js-product-slide-now').length > 0) {

    //   function checkSliderSlideCount() {
    //     console.log("checkSliderSlideCount : ");
    //     let slideCount = $('.js-product-slide-now .slick-slide').length;  // Get total number of slides
    //     if (slideCount <= 6) {
    //       $('.js-product-slide-now').addClass('no-slide-translate');
    //     } else {
    //       $('.js-product-slide-now').removeClass('no-slide-translate');
    //     }
    //   }

    //     $('.js-product-slide-for').slick({
    //         slidesToShow: 1,
    //         slidesToScroll: 1,
    //         arrows: true,
    //         prevArrow: '<button type="button" class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.380859 6.99986C0.380859 7.42782 0.710146 7.77475 1.11634 7.77475L14.464 7.77475C14.8702 7.77475 15.1995 7.42782 15.1995 6.99986C15.1995 6.5719 14.8702 6.22497 14.464 6.22497L1.11634 6.22498C0.710146 6.22498 0.380859 6.5719 0.380859 6.99986Z" fill="#31473A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M0.215418 6.45205C-0.0718057 6.75466 -0.0718056 7.24529 0.215418 7.5479L5.55447 13.173C5.8417 13.4756 6.30738 13.4756 6.5946 13.173C6.88182 12.8704 6.88182 12.3798 6.5946 12.0772L1.77561 6.99998L6.5946 1.92279C6.88182 1.62018 6.88182 1.12955 6.5946 0.826935C6.30738 0.524322 5.8417 0.524322 5.55447 0.826935L0.215418 6.45205Z" fill="#31473A"/></svg></button>',
    //         nextArrow: '<button type="button" class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.6191 6.99986C15.6191 7.42782 15.2899 7.77475 14.8837 7.77475L1.53602 7.77475C1.12983 7.77475 0.800542 7.42782 0.800542 6.99986C0.800542 6.5719 1.12983 6.22497 1.53602 6.22497L14.8837 6.22498C15.2899 6.22498 15.6191 6.5719 15.6191 6.99986Z" fill="#31473A"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.7846 6.45205C16.0718 6.75466 16.0718 7.24529 15.7846 7.5479L10.4455 13.173C10.1583 13.4756 9.69262 13.4756 9.4054 13.173C9.11818 12.8704 9.11818 12.3798 9.4054 12.0772L14.2244 6.99998L9.4054 1.92279C9.11818 1.62018 9.11818 1.12955 9.4054 0.826935C9.69262 0.524322 10.1583 0.524322 10.4455 0.826935L15.7846 6.45205Z" fill="#31473A"/></svg></button>',
    //         fade: true,
    //         asNavFor: '.js-product-slide-now',
    //         // adaptiveHeight: true,
    //         touchThreshold: 5,
    //         swipe: true,
    //         swipeToSlide: true,
    //         infinite: false,
    //         speed: 500,
    //     });
    //     $('.js-product-slide-now').on('init', function(slick) {
    //       checkSliderSlideCount(); 
    //     }).slick({
    //         slidesToShow: 6,
    //         slidesToScroll: 1,
    //         asNavFor: '.js-product-slide-for',
    //         dots: false,
    //         centerMode: false,
    //         focusOnSelect: true,
    //         arrows: false,
    //         infinite: false,    
    //         speed: 500,
    //     }); 

    //     $('.js-product-slide-now').on('afterChange', function(event, slick, currentSlide) {
    //       checkSliderSlideCount();
    //     });
    // }


    $('body').on('click', '.quantity .plus', function (e) {
        e.preventDefault();
        let $input = $(this).siblings("[name='quantity']");
        let quantity = parseInt($input.val());
        let updatedQuantity = quantity + 1;
        $input.val(updatedQuantity);
    });

    $('body').on('click', '.quantity .minus', function (e) {
        e.preventDefault();
        let $input = $(this).siblings("[name='quantity']");
        let quantity = parseInt($input.val());
        let updatedQuantity = quantity - 1;
        if (updatedQuantity <= 1) {
            updatedQuantity = 1; 
        }
        $input.val(updatedQuantity);
    });


    $("body").on("click", '.js-product-faq__content-text-header',function () {
        if ($(this).parent().hasClass("active")) {
            $(this).parent().removeClass("active");
            $(this).parent().find('.js-product-faq__content-text-body').slideUp();
        } else {
            $(".js-product-faq-content-text").removeClass("active");
            $(this).parent().addClass("active");
            $(".js-product-faq__content-text-body").slideUp(500);
            $(this).parent().find('.js-product-faq__content-text-body')
                .slideDown(500);
        }
    });
    // if ($('.js-product-faq-content-text').length > 0) {
    //     $('.js-product-faq-content-text').first().addClass('active');
    //     $('.js-product-faq-content-text').first().find('.js-product-faq__content-text-body').slideDown();
    // }


// POST commands to YouTube or Vimeo API
// function postMessageToPlayer(player, command){
//   if (player == null || command == null) return;
  
//   console.log(player, command);
//   player.contentWindow.postMessage(JSON.stringify(command), "*");
// }

// // When the slide is changing
// function playPauseVideo(slick, control){
//   var currentSlide, slideType, startTime, player, video;

//   currentSlide = slick.find('.slick-current').find(".product-slide-for__img");
//   slideType = currentSlide.attr("data-video_type");
//   player = currentSlide.find("iframe").get(0);
//   startTime = 0;


//   if (slideType == "vimeo") {
//     switch (control) {
//       case "play":
//         if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
//           currentSlide.addClass('started');
//           postMessageToPlayer(player, {
//             "method": "setCurrentTime",
//             "value" : startTime
//           }); 
//         }
//         postMessageToPlayer(player, {
//           "method": "play",
//           "value" : 1
//         });
//         break;
//       case "pause":
//         postMessageToPlayer(player, {
//           "method": "pause",
//           "value": 1
//         });
//         break;
//     }
//   } else if (slideType == "youtube") {
//     switch (control) {
//       case "play":
//         postMessageToPlayer(player, {
//           "event": "command",
//           "func": "unmute"
//         });
//         postMessageToPlayer(player, {
//           "event": "command",
//           "func": "playVideo"
//         });
//         break;
//       case "pause":
//         postMessageToPlayer(player, {
//           "event": "command",
//           "func": "pauseVideo"
//         });
//         break;
//     }
//   } else if (slideType === "video") {
//     video = $(currentSlide).find('video')[0];
//     console.log("sssss sss");
//     if (video != null) {
//       if (control === "play"){
//         video.play();
//       } else {
//         video.pause();
//       }
//     }
//   }
// }


//     if($('.js-product-slide-for').length > 0) {
//         setTimeout(function() {
//             $('.js-product-slide-for').on("init", function(slick){
//                 slick = $(slick.currentTarget);
//                 setTimeout(function(){
//                   playPauseVideo(slick,"play");
//                 }, 1000);
//               });
//               $('.js-product-slide-for').on("beforeChange", function(event, slick) {
//                 slick = $(slick.$slider);
//                 playPauseVideo(slick,"pause");
//               });
//               $('.js-product-slide-for').on("afterChange", function(event, slick) {
//                 slick = $(slick.$slider);
//                 playPauseVideo(slick,"play");
//               });
//         },1000);
//     }

    $('body').on('change','#selling_plan_id', function () {
      var selected = $(this).find('option:selected');
      var priceHTML = selected.data('price-html');
      var saveBadge = selected.data('save-badge');
      var subscribe_and_sav = $(this).closest('.subscribe-and-sav');
      var productContainer = $(this).closest('.eq_product');

      subscribe_and_sav.find('.price').html(priceHTML);
      $(this).closest('.eq_product').find('.price_wrraper_block').find('.price').html(priceHTML);
      console.log($(this).closest('.eq_product').find('.price_wrraper_block'));

      if (saveBadge) {
        subscribe_and_sav.find('.save-badge').show().html(saveBadge);
        $(this).closest('.eq_product').find('.price_wrraper_block').find('.save-badge').show().html(saveBadge);
      } else {
        subscribe_and_sav.find('.save-badge').hide();
        $(this).closest('.eq_product').find('.price_wrraper_block').find('.save-badge').hide();
      }

       $(this).closest('.eq_product').find('input[name="selling_plan"]').val(selected.val());

       // Clear the previous cart error and restore the button.
        var productForm = $(this).closest('product-form')[0] || productContainer.find('product-form')[0];
        productForm?.resetCartError();
    });


    $('body').on("change",'input[name="subscribe-and-save-widget"]',function () {
      const subscribeOption = $('#subscribe-and-save');
      const oneTimeOption = $('#one-time-purchase');
      const productContainer = $(this).closest('.eq_product');
      
      if (this.id === 'subscribe-and-save') {
        subscribeOption.prop('checked', true).attr('checked', 'checked');
        oneTimeOption.prop('checked', false).removeAttr('checked');

        const selectedPlan = $('#selling_plan_id').val();
        $('input[name="selling_plan"]').val(selectedPlan);

        $('#selling_plan_id').prop('disabled', false).trigger('change');
      } else {
        oneTimeOption.prop('checked', true).attr('checked', 'checked');
        subscribeOption.prop('checked', false).removeAttr('checked');

        $('input[name="selling_plan"]').val('');
        $('#selling_plan_id').prop('disabled', true);

        $(this).closest('.eq_product').find('.price_wrraper_block').html($(this).closest('.eq_product').find('#one-time-purchase-price').html());

        // Clear the cart error and restore the button.
        const productForm = $(this).closest('product-form')[0] || productContainer.find('product-form')[0];
        productForm?.resetCartError();
      }
    });


     /* product page main slider start*/
    if ($('.js-product-slide-for').length > 0 && $('.js-product-slide-now').length > 0) {

    let swiperThumbs = new Swiper(".swiper-product-thumbs", {
      slidesPerView: 6,
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          spaceBetween: 16,
        }
      }
    });

    let swiperMain = new Swiper(".swiper-product-for", {
      navigation: {
        nextEl: ".next-arrow",
        prevEl: ".prev-arrow"
      },
      thumbs: {
        swiper: swiperThumbs
      },
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      speed: 500,
      on: {
        init: function () {
          playPauseVideo(this.el, "play");
        },
        slideChangeTransitionStart: function () {
          playPauseVideo(this.el, "pause");
        },
        slideChangeTransitionEnd: function () {
          playPauseVideo(this.el, "play");
        }
      }
    });

  }

  
  // Helper to send commands to iframe players
  function postMessageToPlayer(player, command) {
    if (!player || !command) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  // Main media controller
  function playPauseVideo(swiperEl, action) {
    const $slides = $(swiperEl).find('.swiper-slide');

    $slides.each(function () {
      const $slide = $(this);
      const isActive = $slide.hasClass("swiper-slide-active");

      // Handle HTML5 <video>
      const video = $slide.find("video").get(0);
      if (video) {
        if (action === "play" && isActive) {
          video.play();
        } else {
          video.pause();
        }
      }

      // Handle iframe players (YouTube/Vimeo)
      const iframe = $slide.find("iframe").get(0);
      if (iframe) {
        const src = $(iframe).attr('src') || "";

        if (src.includes("youtube")) {
          const ytCommand = {
            event: "command",
            func: isActive && action === "play" ? "playVideo" : "pauseVideo",
            args: []
          };
          if (isActive && action === "play") {
            postMessageToPlayer(iframe, { event: "command", func: "unmute" });
          }
          postMessageToPlayer(iframe, ytCommand);

        } else if (src.includes("vimeo")) {
          const vmCommand = {
            method: isActive && action === "play" ? "play" : "pause"
          };
          postMessageToPlayer(iframe, vmCommand);
        }
      }
    });
  }
  /* product page main slider end*/
  

});

